import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/leis-auth.scss'
import Moment from 'moment';

const Licitacao = (props) => {
    const dataLic = Moment(props.lic.dataLic).utc(false).format("DD [de] MMMM [de] YYYY")
    if (props.lic.ata || props.lic.aviso || props.lic.justificativa || props.lic.homologacao || props.lic.pgto) {
        var urlAta = `/transparencia${props.lic.ata}`
        var urlAviso = `/transparencia${props.lic.aviso}`
        var urlEdital = `/transparencia${props.lic.edital}`
        if (props.lic.homologacao) {
            var urlHomog1 = `/transparencia${props.lic.homologacao.homologacao1}`
            var urlHomog2 = `/transparencia${props.lic.homologacao.homologacao2}`
            var urlHomog3 = `/transparencia${props.lic.homologacao.homologacao3}`
            var urlHomog4 = `/transparencia${props.lic.homologacao.homologacao4}`
            var urlHomog5 = `/transparencia${props.lic.homologacao.homologacao5}`
        }
        var urlTermo = `/transparencia${props.lic.termoRef}`
        var urlProj = `/transparencia${props.lic.projetoBasico}`
        var urlConvite = `/transparencia${props.lic.convite}`
        var urlCnpj = `/transparencia${props.lic.cnpj}`
        var urlDeclara = `/transparencia${props.lic.declaracao}`
        var urlJust = `/transparencia${props.lic.justificativa}`
        var urlMem = `/transparencia${props.lic.memorando}`
        var urlLiq = `/transparencia${props.lic.liquidacao}`
        if (props.lic.pgto) {
            var urlPgto1 = `/transparencia${props.lic.pgto.pgto1}`
            var urlPgto2 = `/transparencia${props.lic.pgto.pgto2}`
            var urlPgto3 = `/transparencia${props.lic.pgto.pgto3}`
            var urlPgto4 = `/transparencia${props.lic.pgto.pgto4}`
            var urlPgto5 = `/transparencia${props.lic.pgto.pgto5}`
            var urlPgto6 = `/transparencia${props.lic.pgto.pgto6}`
        }
    }

    function renderButtons(props) {
        const buttons = [];

        if (props.lic.anexos.length > 0) {
            props.lic.anexos.forEach((anexo, index) => {
                buttons.push(
                    <Fragment key={`anexo-${index}`}>
                        <a href={anexo.arquivo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">{anexo.nomeAnexo}</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            });
        }

        if (props.lic.ata) {
            buttons.push(
                <Fragment key="ata">
                    <a href={urlAta} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Ata</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.aviso) {
            buttons.push(
                <Fragment key="aviso">
                    <a href={urlAviso} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Aviso de Edital</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.edital) {
            buttons.push(
                <Fragment key="edital">
                    <a href={urlEdital} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Edital Completo</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.homologacao) {
            if (props.lic.homologacao.homologacao1) {
                buttons.push(
                    <Fragment key="homologacao1">
                        <a href={urlHomog1} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Homologação 1</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.homologacao.homologacao2) {
                buttons.push(
                    <Fragment key="homologacao2">
                        <a href={urlHomog2} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Homologação 2</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.homologacao.homologacao3) {
                buttons.push(
                    <Fragment key="homologacao3">
                        <a href={urlHomog3} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Homologação 3</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.homologacao.homologacao4) {
                buttons.push(
                    <Fragment key="homologacao4">
                        <a href={urlHomog4} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Homologação 4</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.homologacao.homologacao5) {
                buttons.push(
                    <Fragment key="homologacao5">
                        <a href={urlHomog5} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Homologação 5</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
        }

        if (props.lic.termoRef) {
            buttons.push(
                <Fragment key="termoRef">
                    <a href={urlTermo} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Termo de Referência</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.projetoBasico) {
            buttons.push(
                <Fragment key="projetoBasico">
                    <a href={urlProj} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Projeto Básico</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.convite) {
            buttons.push(
                <Fragment key="convite">
                    <a href={urlConvite} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Carta Convite</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.cnpj) {
            buttons.push(
                <Fragment key="cnpj">
                    <a href={urlCnpj} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">CNPJ</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.declaracao) {
            buttons.push(
                <Fragment key="declaracao">
                    <a href={urlDeclara} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Declaração de Exclusividade</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.justificativa) {
            buttons.push(
                <Fragment key="justificativa">
                    <a href={urlJust} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Justificativa de Exclusividade</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.memorando) {
            buttons.push(
                <Fragment key="memorando">
                    <a href={urlMem} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Memorando</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.liquidacao) {
            buttons.push(
                <Fragment key="liquidacao">
                    <a href={urlLiq} target="_blank" rel="noreferrer">
                        <Button type="button" variant="primary">Liquidacao</Button>
                    </a>
                    <br />
                    <br />
                </Fragment>
            );
        }

        if (props.lic.pgto) {
            if (props.lic.pgto.pgto1) {
                buttons.push(
                    <Fragment key="pgto1">
                        <a href={urlPgto1} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 1</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.pgto.pgto2) {
                buttons.push(
                    <Fragment key="pgto2">
                        <a href={urlPgto2} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 2</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.pgto.pgto3) {
                buttons.push(
                    <Fragment key="pgto3">
                        <a href={urlPgto3} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 3</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.pgto.pgto4) {
                buttons.push(
                    <Fragment key="pgto4">
                        <a href={urlPgto4} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 4</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.pgto.pgto5) {
                buttons.push(
                    <Fragment key="pgto5">
                        <a href={urlPgto5} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 5</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
            if (props.lic.pgto.pgto6) {
                buttons.push(
                    <Fragment key="pgto6">
                        <a href={urlPgto6} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Pagamento 6</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
        }

        return buttons;
    }
    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>Processo N° {props.lic.processo}/{props.lic.ano}</h5></Card.Header>
                    <Card.Body>
                        <Card.Text>
                            {props.lic.licitacao ? <p><strong>{props.lic.modalidade} Nº{props.lic.licitacao}</strong></p> : ''}
                            <p><strong>Objeto: </strong>{props.lic.objeto}</p>
                            {props.lic.unidadeGestora ?
                                <p><strong>Unidade Gestora: </strong>{props.lic.unidadeGestora}</p> :
                                <Fragment>
                                    <strong>Unidades Gestoras:</strong>
                                    {props.lic.unidadeG.map((fundo) =>
                                        <p>{fundo}</p>
                                    )}
                                </Fragment>
                            }
                            <p><strong>Licitação: </strong>{props.lic.licitacao}</p>
                            {props.lic.valor ? <p><strong>Valor: </strong>{props.lic.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p> : ''}
                            <p><strong>Lei Benefício 123: </strong>{props.lic.leiBeneficio}</p>
                            {props.lic.orgao ?
                                <p><strong>Órgão Solicitante: </strong>{props.lic.orgao}</p> :
                                <Fragment>
                                    <strong>Órgãos Solicitantes:</strong>
                                    {props.lic.orgaoS.map((org) =>
                                        <p>{org}</p>
                                    )}
                                </Fragment>
                            }
                            <p><strong>Situação: </strong>{props.lic.situacao}</p>
                            {props.lic.orgaoSRP ? <p><strong>Órgão Gerenciador (Ata de Adesão - SRP): </strong>{props.lic.orgaoSRP}</p> : ''}
                            {props.lic.observacao ? <p><strong>Observação: </strong>{props.lic.observacao}</p> : ''}
                            <p><strong>Data e hora do Certame: </strong>{dataLic} - {props.lic.hora}</p>
                        </Card.Text>
                        {renderButtons(props)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Licitacao;